"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = typesAliasFromDefs;

var _lodash = _interopRequireDefault(require("lodash.merge"));

function typesAliasFromDefs(definitions, initAlias = {}) {
  return Object.values(definitions).reduce((res, {
    typesAlias
  }) => (0, _lodash.default)({}, typesAlias, res), initAlias);
}